import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PlaygroundHero from './components/PlaygroundHero';
import FeatureStrip from './components/FeatureStrip';
import BioStampSection from './components/BioStampSection';
import SendStampSection from './components/SendStampSection';
import LiveVerificationStage from './components/LiveVerificationStage';
import EcosystemDiagram from './components/EcosystemDiagram';
import ExploreTech from './components/ExploreTech';
import ProtectTrust from './components/ProtectTrust';

export default function Playground() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <PlaygroundHero />
        <FeatureStrip />
        <BioStampSection />
        <SendStampSection />
        <LiveVerificationStage />
        <EcosystemDiagram />
        <ExploreTech />
        <ProtectTrust />
      </main>
      <Footer />
    </div>
  );
}